import type { Maybe, OptionalPromise } from '@adornis/base/utilTypes.js';
import type { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

export function useFormIDProxy<T extends MongoEntity>(
  fetcher: (id: string) => OptionalPromise<Maybe<T>>,
  updater: () => void,
) {
  const cache = new Map<string, Maybe<T>>();

  return {
    value(id: string) {
      if (cache.has(id)) {
        return cache.get(id);
      }

      const res = fetcher(id);
      if (res instanceof Promise) {
        (res as Promise<Maybe<T>>)
          .then(value => {
            cache.set(id, value);
            updater();
          })
          .catch(console.error);
      } else {
        cache.set(id, res as Maybe<T>);
        return res;
      }

      return null;
    },
  };
}
